export type CampaignType = 'email' | 'sms' | 'mixed'
export type LeadStatus = 'pending' | 'contacted' | 'snoozed'

export interface Lead {
  id: string
  name: string
  phone: string
  email: string
  loanAmount: number
  loanPurpose: 'Purchase' | 'Refinance'
  lastContact: string
  nextFollowUp: string
  campaignName: string
  campaignType: CampaignType
  status: LeadStatus
}

export const MOCK_LEADS: Lead[] = [
  {
    id: 'L-1001',
    name: 'Sarah Jenkins',
    phone: '(555) 123-4567',
    email: 'sarah.j@example.com',
    loanAmount: 450000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-24T14:30:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'First-Time Buyer Nurture',
    campaignType: 'email',
    status: 'pending',
  },
  {
    id: 'L-1002',
    name: 'Michael Chen',
    phone: '(555) 987-6543',
    email: 'mchen88@example.com',
    loanAmount: 320000,
    loanPurpose: 'Refinance',
    lastContact: '2023-10-20T09:15:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'Rate Drop Alert',
    campaignType: 'sms',
    status: 'pending',
  },
  {
    id: 'L-1003',
    name: 'Emily & David Rodriguez',
    phone: '(555) 456-7890',
    email: 'ed.rodriguez@example.com',
    loanAmount: 680000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-25T11:00:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'Pre-Approval Follow-up',
    campaignType: 'mixed',
    status: 'pending',
  },
  {
    id: 'L-1004',
    name: 'James Wilson',
    phone: '(555) 222-3333',
    email: 'jwilson.tech@example.com',
    loanAmount: 510000,
    loanPurpose: 'Refinance',
    lastContact: '2023-10-22T16:45:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'Cash-Out Refi Education',
    campaignType: 'email',
    status: 'contacted',
  },
  {
    id: 'L-1005',
    name: 'Amanda Foster',
    phone: '(555) 777-8888',
    email: 'afoster22@example.com',
    loanAmount: 290000,
    loanPurpose: 'Purchase',
    lastContact: '2023-10-26T10:20:00Z',
    nextFollowUp: new Date().toISOString(),
    campaignName: 'Credit Repair Journey',
    campaignType: 'sms',
    status: 'pending',
  },
]
